import type { ReactNode } from "react";
import { type Toast } from "react-hot-toast";
import { Link } from "react-router";

import { useURL } from "~/contexts";

import { TickIcon } from "../ui/icons/tick";
import { Text } from "../ui/text";

type Props = {
  message: string;
  t: Toast;
  children?: ReactNode;
  childrenClassname?: string;
  isLoggedIn?: boolean;
};
const ToastNeutral = ({ message, isLoggedIn }: Props) => {
  const url = useURL();
  return (
    <>
      <div className="min-w-[250px] max-w-[312px] items-center rounded-sm bg-white p-4 shadow-lg md:max-w-[363px]">
        <div className="flex flex-col items-center justify-between gap-2">
          <div className="h-4 w-4 items-center rounded-full pl-[1.5px] pt-[2px] align-middle outline outline-black">
            <TickIcon color="black" />
          </div>
          <Text className="text-base font-bold">{message}</Text>
          <Link
            className="text-sm decoration-brown-8"
            to={isLoggedIn ? url("/account/wishlist") : url("/wishlist")} // TODO: there was some issue with doing it this way
          >
            View Wishlist
          </Link>
        </div>
      </div>
    </>
  );
};

export default ToastNeutral;
